export const conclusion: { [key: string]: string } = {
  name: "Наименование заключения",
  responseDate: "Дата выдачи заключения",
  isActual: "Действительно",
};
